import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    inject,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { IAppServiceLanguages } from '@app/app.interface';
import { AppService } from '@app/app.service';
import { AppHelper } from '@app/core/app.helper';
import { TokenStorage } from '@app/core/token.storage';
import { NotificationsService } from '@app/modules/notifications/notifications.service';
import { SocketsService } from '@fui/fui-sockets';
import { FuiDestroyService } from '@services/destroy.service';
import {
    HeaderComponent_AfterViewInit,
    IHeaderComponent_AfterViewInit,
} from 'src/shared/sockets/layout/header.interface';

/**
 * Класс шапки страницы
 */
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [FuiDestroyService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
    private readonly socketsService = inject(SocketsService);
    private readonly cdr = inject(ChangeDetectorRef);
    private readonly elementRef = inject(ElementRef);

    /** Количество записей профайлера */
    profilerCount: string = '';

    /** Флаг состояние системы (внешняя / внутренняя) */
    @Input() public isPublic: boolean = true;

    /** Данные роута */
    @Input() public routeData: any;

    /** Элемент контейнера страницы */
    private _layoutWrapperContainer: HTMLDivElement;

    @ViewChild('headerRight', { read: ViewContainerRef }) headerRight?: ViewContainerRef;

    /**
     * Установка элемента контейнера страницы
     * @param value элемент контейнера страницы
     */
    @Input()
    set layoutWrapperContainer(value: HTMLDivElement) {
        this._layoutWrapperContainer = value;
    }

    /**
     * Получение элемента контейнера страницы
     */
    get layoutWrapperContainer(): HTMLDivElement {
        return this._layoutWrapperContainer;
    }

    /** Флаг открытого меню */
    public openMenu = false;

    public currentLang: IAppServiceLanguages = null;

    /**
     * Конструктор
     * @param router роутинг
     * @param appService сервис ко внешним ресурсам
     * @param token класс работы с токеном
     * @param dialog диалог
     * @param spinner прелоадер
     * @param notifier сервис всплывающих сообщений
     * @param dialogConfirm диалог подтверждения действия
     * @param service сервис уведомлений
     */
    constructor(
        public appService: AppService,
        public service: NotificationsService,
        public token: TokenStorage,
    ) {
        this.currentLang = AppHelper.getCurrentLanguage(this.appService);
    }

    ngOnInit() {
        if (this.appService.isAuth) {
            if (
                this.appService.accessMatrix &&
                Object.keys(this.appService.accessMatrix).includes('notification_all') &&
                Object.keys(this.appService.accessMatrix.notification_all).includes('show') &&
                this.appService.accessMatrix.notification_all.show === 1 &&
                this.service.notificationFlag === false
            ) {
                this.service.notificationFlag = true;
            }
        }
    }

    ngAfterViewInit(): void {
        if (this.headerRight) {
            this.socketsService.callback<IHeaderComponent_AfterViewInit>(HeaderComponent_AfterViewInit, {
                vcrHeaderRight: this.headerRight,
            });
            this.cdr.detectChanges();
        }
    }

    /**
     * Удалить компонент из DOM-дерева
     * OnDestroy вызывается до удаления компонента из DOM-дерева.
     * Заставляем Angular удалять его сразу после уничтожения компонента т.к.
     * подписки в ngAfterViewInit получают данные из DOM-дерева для манипуляций со стилями и элементами
     * Подробнее в задаче #71391
     */
    ngOnDestroy(): void {
        this.elementRef.nativeElement.parentNode.removeChild(this.elementRef.nativeElement);
    }

    /**
     * Переключение языка
     * @param lang язык
     */
    setCurrentLang(lang: any) {
        this.currentLang = lang;
        this.token.saveCurrentLang(lang.lang);
        window.location.reload();
    }

    /**
     * Сворачивание/разворачивание левого меню
     * @param isPublic флаг публичной страницы
     */
    public onToggleSidenav = (isPublic: boolean) => {
        if (!isPublic) {
            this.layoutWrapperContainer.classList.toggle('layout-wrapper-menu-open');
        }
        this.openMenu = !this.openMenu;
    };
}
